"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.codeTypeMapping = exports.CONFIG = void 0;
var CONFIG = {
  dev: {
    wwwBaseUrl: 'https://www.dev.shutterfly.com',
    tpBaseUrl: 'https://www.dev.tinyprints.com',
    apigeeBaseUrl: 'https://api2.dev.shutterfly.com',
    apigeeApiKey: 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG'
  },
  beta: {
    wwwBaseUrl: 'https://www.beta.shutterfly.com',
    tpBaseUrl: 'https://www.beta.tinyprints.com',
    apigeeBaseUrl: 'https://api2.beta.shutterfly.com',
    apigeeApiKey: 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG'
  },
  kappa: {
    wwwBaseUrl: 'https://www.kappa.shutterfly.com',
    tpBaseUrl: 'https://www.kappa.tinyprints.com',
    apigeeBaseUrl: 'https://api2.kappa.shutterfly.com',
    apigeeApiKey: 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG'
  },
  stage: {
    wwwBaseUrl: 'https://www.stage.shutterfly.com',
    tpBaseUrl: 'https://www.stage.tinyprints.com',
    apigeeBaseUrl: 'https://api2.stage.shutterfly.com',
    apigeeApiKey: 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG'
  },
  production: {
    wwwBaseUrl: 'https://www.shutterfly.com',
    tpBaseUrl: 'https://www.tinyprints.com',
    apigeeBaseUrl: 'https://api2.shutterfly.com',
    apigeeApiKey: 'uWrM911sdIvHivflYxyiHlGgmlgoaV0m'
  },
  // Added following to fix dev1/beta1/kaapa1 env specific errors which's part of cloud AWS migration
  dev1: {
    wwwBaseUrl: 'https://www.dev1.shutterfly.com',
    tpBaseUrl: 'https://www.dev1.tinyprints.com',
    apigeeBaseUrl: 'https://api2.dev1.shutterfly.com',
    apigeeApiKey: 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG'
  },
  beta1: {
    wwwBaseUrl: 'https://www.beta1.shutterfly.com',
    tpBaseUrl: 'https://www.beta1.tinyprints.com',
    apigeeBaseUrl: 'https://api2.beta1.shutterfly.com',
    apigeeApiKey: 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG'
  },
  kappa1: {
    wwwBaseUrl: 'https://www.kappa1.shutterfly.com',
    tpBaseUrl: 'https://www.kappa1.tinyprints.com',
    apigeeBaseUrl: 'https://api2.kappa1.shutterfly.com',
    apigeeApiKey: 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG'
  }
};
exports.CONFIG = CONFIG;
var codeTypeMapping = {
  PROMOTION: 'Promotion',
  GIFT_CARD: 'Gift card',
  GIFT_CERT: 'Gift certificate'
};
exports.codeTypeMapping = codeTypeMapping;